export default {
  eyebrow: 'Portale partner',
  title: 'Tasse e valuta',
  description: 'Categorie fiscali predefinite ereditate dai tuoi ristoranti, salvo override individuale.',
};
